<template>
    <vue-scroll>
        <div class="page-header">
            <h1>{{ community.name }}</h1>
        </div>
        <div v-loading="loading">
            <div class="header-with-line mb-4">
                <img src="/images/dashboard/icon_proof.svg" class="check-img" />
                <h2>Newsletter Proofs</h2>
                <div class="line"></div>
            </div>
            <div
                v-if="
                    community.newsletter_pdf_order &&
                    community.newsletter_proof_link
                "
            >
                <div style="position: relative; z-index: 99; float: right">
                    <el-button
                        type="primary"
                        v-if="displayApproval"
                        @click="approveDialogVisible = true"
                        >Approve for Print</el-button
                    >
                    <div v-if="!displayApproval">
                        Order Status: {{ getOrderStatus }}
                    </div>
                </div>
                <el-row class="news-proof">
                    <el-col :span="6">{{ community.newsletter_name }}</el-col>
                    <el-col :span="4">{{
                        community.newsletter_pdf_order.formatted_month
                    }}</el-col>
                </el-row>
                <div id="dropbox_files" class="dropbox-embed"></div>
            </div>
        </div>
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="approveDialogVisible"
            title="Approve for Print"
            width="500px"
        >
            <el-form @submit.native.prevent style="max-width: 500px">
                <div>
                    Please proofread carefully.<br />
                    Approval indicates responsibility for layout and copy/text.
                </div>
                <el-form-item class="mb-0 mt-20" label="">
                    <el-checkbox
                        name="approve"
                        v-model="form.approve"
                        v-validate="'required'"
                        @change="checkApprove"
                    >
                        Looks good, please print!
                    </el-checkbox>
                    <form-feedback :form="form" field="approve" />
                </el-form-item>
                <div class="error-text" v-show="approveErrorVisible">
                    Please check this box to send your approval to print
                </div>
                <el-form-item class="mb-0 mt-20" label="Comments">
                    <el-input
                        type="textarea"
                        v-model="form.comments"
                        rows="5"
                        maxlength="400"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="approveDialogVisible = false"
                    >Cancel</el-button
                >
                <el-button
                    type="primary"
                    :loading="form.busy"
                    @click="approve()"
                    >Send to Print</el-button
                >
            </div>
        </el-dialog>
    </vue-scroll>
</template>

<script>
import { mapState } from "vuex";
import * as Actions from "@/store/constants/actions";
import * as DBX from "@/plugins/dropins";
import * as Statuses from "@/constants/order-statuses";
import order_status_mixin from "@/mixins/order-status";

export default {
    mixins: [order_status_mixin],
    data() {
        return {
            loading: false,
            approveDialogVisible: false,
            approveErrorVisible: false,
            form: new Form({
                approve: false,
                comments: "",
            }),
            orderStatus: "",
        };
    },
    mounted() {
        if (this.community.newsletter_pdf_order) {
            //console.log(this.community.newsletter_pdf_order);
            this.orderStatus =
                this.community.newsletter_pdf_order.detailed_status;
        }
        let embed_instance = null;
        this.getFiles();
    },
    computed: {
        ...mapState({
            community: (state) => _.cloneDeep(state.current_community),
        }),
        getOrderStatus() {
            return this.getOrderStatusName(this.orderStatus);
        },
        displayApproval() {
            if (
                this.orderStatus.toLowerCase() ===
                    Statuses.EMAILED_TO_CLIENT.toLowerCase() ||
                this.orderStatus.toLowerCase() ===
                    Statuses.NEEDS_APPROVAL.toLowerCase()
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        getFiles() {
            let vm = this;
            if (
                typeof Dropbox.embed !== "undefined" &&
                vm.community.newsletter_proof_link
            ) {
                Dropbox.appKey =
                    vm.$store.state.config.settings.dropbox_app_key;
                let options = {
                    // Shared link to Dropbox file
                    link: vm.community.newsletter_proof_link,
                    file: {
                        // Sets the zoom mode for embedded files. Defaults to 'best'.
                        zoom: "fit", //"best" // or "fit"
                    },
                    folder: {
                        // Sets the view mode for embedded folders. Defaults to 'list'.
                        view: "grid", //"list", // or "grid"
                        headerSize: "small", //"normal" // or "small"
                    },
                };
                let element = document.getElementById("dropbox_files");
                this.embed_instance = Dropbox.embed(options, element);
            } else {
                console.log("embed undefined");
            }
        },
        dateFormat(datetime) {
            return moment(datetime).format("MMM DD, YYYY");
        },
        viewFile(file) {
            window.open(
                this.community.newsletter_proof_link + "?preview=" + file.name,
                "_blank"
            );
        },
        approve() {
            if (!this.form.approve) {
                this.approveErrorVisible = true;
                return false;
            }
            //post action: save to database, send email, updates order status
            axios
                .post(
                    `/web-api/order/${this.community.newsletter_pdf_order.id}/newsletter-proof-status`,
                    this.form
                )
                .then(() => {
                    this.orderStatus = "PDF Approved";
                    this.$notify.success({
                        message: "Approval sent",
                    });
                })
                .finally(() => {
                    this.approveDialogVisible = false;
                });
            return true;
        },
        checkApprove() {
            if (this.approveErrorVisible) {
                this.approveErrorVisible = false;
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.embed_instance) {
            Dropbox.unmount(this.embed_instance);
        }
        next();
    },
};
</script>

<style scoped>
.header-with-line .check-img {
    height: 65px;
    width: 65px;
}
.news-proof {
    margin: 20px;
}
.printed-status {
    color: #606266;
}
.designed-status {
    color: #86b142;
}
.printing-status {
    color: #1c41c9;
}
.pdf-approved-status {
    color: #c2111b;
}
.pdf-emailed-status {
    color: #d34ad5;
}
.proofed-status {
    color: #6385d8;
}
.paid-status {
    color: #008000;
}
.due-status {
    color: #0000ff;
}
.overdue-status {
    color: #ff0000;
}
.file-name {
    color: #000;
}
.file-data {
    font-size: 14px;
}
.dropbox-embed {
    height: 600px;
    width: auto;
}
.error-text {
    font-style: italic;
    color: #ff0000;
}
</style>
